import { MRT_ColumnDef } from "material-react-table";
import { useNavigate, useLocation } from "react-router";
import { URLHandler } from "src/services/URLHandler";
import { GridProduct } from "src/api/client-api/products/useGetAllproduct";
import { useProductColumns } from "./useProductColumns";
import { useFoodpilotContext } from "src/context/FoodpilotContext";
import { useGetAllBrands } from "src/api/client-api/brand/useGetAllBrand";

type IntermediateProductColumnsOptions = {
    brandExistenceQuery: ReturnType<typeof useGetAllBrands>;
    brandFilterQuery: ReturnType<typeof useGetAllBrands>;
    data: GridProduct[];
    gridKey: string;
};

export const useIntermediateProductColumns = (
    options: IntermediateProductColumnsOptions,
): MRT_ColumnDef<GridProduct, any>[] => {
    const navigate = useNavigate();
    const location = useLocation();
    const { selectedCompany } = useFoodpilotContext();

    // Get the base columns from useProductColumns
    const baseColumns = useProductColumns(options);

    // Override the title column to use intermediateProduct URLs
    return baseColumns.map((column) => {
        if (column.id === "title") {
            return {
                ...column,
                Cell: (value: any) => {
                    const GridLink = (props: any) => <span style={{ cursor: "pointer" }} {...props} />;
                    const GridText = (props: any) => <span {...props} />;

                    return value.row.original.canView ?
                            <GridLink
                                onClick={() => {
                                    if (selectedCompany === null) return;
                                    const productId = value.row.original.id;
                                    const currentUrl = location.pathname + location.search;
                                    const scoresUrl = URLHandler.intermediateProduct.scores(
                                        selectedCompany.id,
                                        productId,
                                    );
                                    navigate(`${scoresUrl}?returnUrl=${encodeURIComponent(currentUrl)}`);
                                }}
                                sx={{
                                    color: (theme: any) => theme.palette.primary[700],
                                    "&:hover": { textDecoration: "underline" },
                                }}
                            >
                                {value.renderedCellValue}
                            </GridLink>
                        :   <GridText value={value.renderedCellValue}></GridText>;
                },
            };
        }
        return column;
    });
};
